module.exports = __webpack_public_path__ + "static/media/sample-tags.aacbe5a4.csv";